/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PinnedAt
 */
export interface PinnedAt {
}

/**
 * Check if a given object implements the PinnedAt interface.
 */
export function instanceOfPinnedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PinnedAtFromJSON(json: any): PinnedAt {
    return PinnedAtFromJSONTyped(json, false);
}

export function PinnedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinnedAt {
    return json;
}

export function PinnedAtToJSON(value?: PinnedAt | null): any {
    return value;
}

